import { render, staticRenderFns } from "./GuestOrdersView.vue?vue&type=template&id=87b85f4e"
import script from "./GuestOrdersView.vue?vue&type=script&lang=js"
export * from "./GuestOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports